import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('AdminController', AdminController);

    function AdminController($state, AuthFactory) {
        var vm = this;

        init();

        function init() {
            readMe();
            switch (location.host) {
                case 'local.iwykonawca.pl':
                    vm.nextIwUrl = 'superadmin.local.iwykonawca.pl/api/superadmin';
                    break;
                case 'dev.iwykonawca.pl':
                    vm.nextIwUrl = 'superadmin-dev.iwykonawca.pl/api/superadmin';
                    break;
                case 'iwykonawca.pl':
                    vm.nextIwUrl = 'superadmin.iwykonawca.pl/api/superadmin';
                    break;
            }
        }

        function readMe() {
            AuthFactory.readMe().then(
                function (response) {
                    vm.isSuperuser = response.data.is_superuser;

                    if (vm.isSuperuser) {
                        vm.dataFromBackendForDisplayName = response.data;
                    } else {
                        $state.go('login');
                    }
                },
                function () {
                    $state.go('login');
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/_admin/_admin.controller.ts